import {ACTION} from './constant';
import request from '../../../../utils/request';
import {requestConfig} from "../../../../config/apiResource";
import {showMainLoader, hideMainLoader} from '../../../actions';

export function getGlossaryData(formData) {
    return dispatch => {
        // dispatch(showMainLoader());
        return request(requestConfig.getGlossaryData(formData))
            .then((json) => {
                // dispatch(hideMainLoader());
                json && dispatch({ type: ACTION.GET_GLOSSARY_DATA , data: json.data });
                return json;
            }).catch((error) => {
                // dispatch(hideMainLoader());
                console.log("Got Error with Glossary content API: " + error);
            });
    }
}

export function getGlossaryAlphabet() {
    return dispatch => {
        // dispatch(showMainLoader());
        return request(requestConfig.getGlossaryAlphabet())
            .then((json) => {
                // dispatch(hideMainLoader());
                json && dispatch({ type: ACTION.GET_GLOSSARY_ALPHABET , data: json.data });
                return json;
            }).catch((error) => {
                // dispatch(hideMainLoader());
                console.log("Got Error with Glossary Alphabet API: " + error);
            });
    }
}